import type { ClientToServer, ServerToClient, ModelChoice } from "@lupp/shared";
import { getSocket } from "./socket";

export async function fetchModels(): Promise<ModelChoice[]> {
  const socket = getSocket();

  return new Promise<ModelChoice[]>((resolve, reject) => {
    const onEvent = (event: ServerToClient): void => {
      if (event.type === "model_list_result") {
        cleanup();
        resolve(event.models);
      } else if (event.type === "auth_required") {
        cleanup();
        reject(new Error("auth required"));
      } else if (event.type === "error") {
        cleanup();
        reject(new Error(event.message));
      }
    };

    const cleanup = (): void => {
      socket.off("event", onEvent as Parameters<typeof socket.off>[1]);
    };

    socket.on("event", onEvent as Parameters<typeof socket.on>[1]);
    socket.emit("model_list", { type: "model_list" } satisfies ClientToServer);
  });
}
